var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section"
  }, [_c('Modal', {
    attrs: {
      "width": "800"
    },
    model: {
      value: _vm.isShowchooseRecipeModal,
      callback: function ($$v) {
        _vm.isShowchooseRecipeModal = $$v;
      },
      expression: "isShowchooseRecipeModal"
    }
  }, [_c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_vm._v(" " + _vm._s(_vm.salesOrder ? _vm.salesOrder.abbr : "") + " ")]), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.recipetotalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.recipetotalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadRecipe
    }
  })], 1)]), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.recipeSalesList,
      "loading": _vm.recipeLoading,
      "height": _vm.tableHeight
    },
    on: {
      "on-row-click": _vm.chooseRecipe
    }
  })], 1)]), _c('h2', {
    staticClass: "section-title"
  }, [_vm._v("生产订单")]), _vm._l(_vm.displayData, function (d) {
    return _c('div', {
      staticClass: "section-block"
    }, [_c('h3', {
      staticClass: "block-title"
    }, [_vm._v(_vm._s(d.title))]), _c('div', {
      class: {
        'block-displaycontent': !d.lock
      },
      on: {
        "click": function ($event) {
          !d.lock && _vm.openRecipeChooseDrawer(d);
        }
      }
    }, [_c('span', {
      staticClass: "block-displaytext"
    }, [_vm._v(_vm._s(d.displayText || "-"))])])]);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }